import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import MfaSetUp from '../../components/client/account/MfaSetUp';
import MfaVerifications from '../../components/client/account/MfaVerifications';

function MfaPage() {
  const { authState } = useContext(AuthContext);

  return (
    <>{authState.account?.otp_required ? <MfaVerifications /> : <MfaSetUp />}</>
  );
}

export default MfaPage;
